import EventLayoutPage from './EventLayoutPage';

export default EventLayoutPage;
